export const defaultLetterSpacingAdjust = {
  bodyXS: 'normal',
  bodyS: 'normal',
  bodyM: 'normal',
  bodyL: 'normal',
  labelXS: 'normal',
  labelS: 'normal',
  labelM: 'normal',
  titleXS: 'normal',
  titleS: 'normal',
  titleM: 'normal',
  titleL: 'normal',
  titleXL: 'normal',
  title2XL: 'normal',
  title3XL: 'normal',
  title4XL: '-1px',
  title5XL: '-1px'
}

export const languageFontSettings = {
  ar: {
    fontFamily: 'Noto Sans Arabic',
    letterSpacingAdjust: {
      bodyXS: '-0.25px',
      bodyS: '-0.25px',
      bodyM: '-0.25px',
      bodyL: '-0.5px',
      labelXS: '-0.25px',
      labelS: '-0.25px',
      labelM: '-0.25px',
      titleXS: '-0.25px',
      titleS: '-0.25px',
      titleM: '-0.25px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  el: {
    fontFamily: 'Noto Sans',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  he: {
    fontFamily: 'Noto Sans Hebrew',
    letterSpacingAdjust: {
      bodyXS: '-0.15px',
      bodyS: '-0.15px',
      bodyM: '-0.15px',
      bodyL: '-0.5px',
      labelXS: '-0.15px',
      labelS: '-0.15px',
      labelM: '-0.15px',
      titleXS: '-0.15px',
      titleS: '-0.15px',
      titleM: '-0.15px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  ja: {
    fontFamily: 'Noto Sans JP',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  ko: {
    fontFamily: 'Noto Sans KR',
    letterSpacingAdjust: {
      bodyXS: '-0.25px',
      bodyS: '-0.25px',
      bodyM: '-0.25px',
      bodyL: '-0.5px',
      labelXS: '-0.25px',
      labelS: '-0.25px',
      labelM: '-0.25px',
      titleXS: '-0.25px',
      titleS: '-0.25px',
      titleM: '-0.25px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  ru: {
    fontFamily: 'Noto Sans',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  th: {
    fontFamily: 'Noto Sans Thai',
    letterSpacingAdjust: {
      bodyXS: '-0.25px',
      bodyS: '-0.25px',
      bodyM: '-0.25px',
      bodyL: '-0.5px',
      labelXS: '-0.25px',
      labelS: '-0.25px',
      labelM: '-0.25px',
      titleXS: '-0.25px',
      titleS: '-0.25px',
      titleM: '-0.25px',
      titleL: '-0.5px',
      titleXL: '-0.5px',
      title2XL: '-0.5px',
      title3XL: '-0.5px',
      title4XL: '-0.5px',
      title5XL: '-0.5px'
    }
  },
  uk: {
    fontFamily: 'Noto Sans',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  zh: {
    fontFamily: 'Noto Sans SC',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  'zh-CN': {
    fontFamily: 'Noto Sans SC',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  'zh-HK': {
    fontFamily: 'Noto Sans HK',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  },
  'zh-TW': {
    fontFamily: 'Noto Sans TC',
    letterSpacingAdjust: {
      bodyXS: '-0.5px',
      bodyS: '-0.5px',
      bodyM: '-0.5px',
      bodyL: '-1px',
      labelXS: '-0.5px',
      labelS: '-0.5px',
      labelM: '-0.5px',
      titleXS: '-0.5px',
      titleS: '-0.5px',
      titleM: '-0.5px',
      titleL: '-1px',
      titleXL: '-1px',
      title2XL: '-1px',
      title3XL: '-1px',
      title4XL: '-1px',
      title5XL: '-1px'
    }
  }
}

export const FALLBACK_FONT_LANGUAGES = new Set([
  'ar',
  'el',
  'he',
  'ja',
  'ko',
  'ru',
  'th',
  'uk',
  'zh-CN',
  'zh-HK',
  'zh-TW',
  'zh'
])

export const nonLatinFontFamilies = {
  ar: 'Noto Sans Arabic',
  el: 'Noto Sans',
  he: 'Noto Sans Hebrew',
  ja: 'Noto Sans JP',
  ko: 'Noto Sans KR',
  ru: 'Noto Sans',
  th: 'Noto Sans Thai',
  uk: 'Noto Sans',
  zh: 'Noto Sans SC',
  'zh-CN': 'Noto Sans SC',
  'zh-HK': 'Noto Sans HK',
  'zh-TW': 'Noto Sans TC'
}

export const fontFaces = `
  @font-face {
    font-family: 'Circular';
    src: url('/assets/fonts/CircularXX-Regular.woff2') format('woff2');
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: 'Circular';
    src: url('/assets/fonts/CircularXX-Book.woff2') format('woff2');
    font-style: normal;
    font-weight: 450;
  }

  @font-face {
    font-family: 'Circular';
    src: url('/assets/fonts/CircularXX-Medium.woff2') format('woff2');
    font-style: normal;
    font-weight: 500;
  }
`

export const fallbackFontFaces = `
  @font-face {
    font-family: 'Circular';
    font-style: normal;
    font-weight: normal;
    src: local('.SFNSText-Regular'),
      local('.HelveticaNeueDeskInterface-Regular'), local('.LucidaGrandeUI'),
      local('Ubuntu Regular'), local('Segoe UI Regular'),
      local('Roboto-Regular'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'Circular';
    font-style: normal;
    font-weight: 500;
    src: local('.SFNSText-Medium'), local('.HelveticaNeueDeskInterface-Medium'),
      local('.LucidaGrandeUI'), local('Ubuntu Medium'), local('Segoe UI Medium'),
      local('Roboto-Medium'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'Circular';
    font-style: normal;
    font-weight: 600;
    src: local('.SFNSText-Semibold'),
      local('.HelveticaNeueDeskInterface-Semibold'), local('.LucidaGrandeUI'),
      local('Ubuntu Semibold'), local('Segoe UI Semibold'),
      local('Roboto-Semibold'), local('DroidSans'), local('Tahoma');
  }

  @font-face {
    font-family: 'Circular';
    font-style: normal;
    font-weight: 700;
    src: local('.SFNSText-Bold'), local('.HelveticaNeueDeskInterface-Bold'),
      local('.LucidaGrandeUI'), local('Ubuntu Bold'), local('Segoe UI Bold'),
      local('Roboto-Bold'), local('DroidSans'), local('Tahoma');
  }
`
